import {
  API_ERROR,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  VENDORS,
  VENDORS_LIST_SUCCESSFUL,
  VENDORS_ADD,
  VENDORS_ADD_SUCCESSFUL,
  VENDORS_EDIT,
  VENDORS_EDIT_SUCCESSFUL,
  VENDORS_DELETE,
  VENDORS_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  // GET_VENDOR_DETAILS,
  // VENDORS_ROW_SUCCESSFUL,
  UPLOAD_REQUEST,
  UPLOAD_PRODUCTVENDORS_REQUEST,
  VENDOR_GST_VALIDATION,
} from "./actionTypes";

export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getVendors = () => {
  return {
    type: VENDORS,
  };
};

export const vendorListSuccessful = (vendors) => {
  return {
    type: VENDORS_LIST_SUCCESSFUL,
    payload: vendors,
  };
};

export const vendorAdd = (vendor, history) => {
  return {
    type: VENDORS_ADD,
    payload: { vendor, history },
  };
};

export const vendorAddSuccessful = (response) => {
  return {
    type: VENDORS_ADD_SUCCESSFUL,
    payload: response,
  };
};
export const vendorEdit = (data) => {
  return {
    type: VENDORS_EDIT,
    payload: data,
  };
};

export const vendorEditSuccessful = (response) => {
  return {
    type: VENDORS_EDIT_SUCCESSFUL,
    payload: response,
  };
};

export const vendorDelete = (venId, history) => {
  return {
    type: VENDORS_DELETE,
    payload: { venId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: VENDORS_SETROWDATA,
    payload: data,
  };
};

// export const getRowVendorDetails = (id, history) => {
//   return {
//     type: GET_VENDOR_DETAILS,
//     payload: { id, history },
//   };
// };

// export const vendor_row_successfull = (products) => {
//   return {
//     type: VENDORS_ROW_SUCCESSFUL,
//     payload: products,
//   };
// };

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const UploadCSVFile = (file, history) => {
  return {
    type: UPLOAD_REQUEST,
    payload: { file, history },
  };
};

export const UploadProductVendorsCSVFile = (file, history) => {
  return {
    type: UPLOAD_PRODUCTVENDORS_REQUEST,
    payload: { file, history },
  };
};
export const vendorGSTValidation = (data) => {
  return {
    type: VENDOR_GST_VALIDATION,
    payload: { data },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
